import { map } from 'lodash'
import { takeLatest, put, all, call } from 'redux-saga/effects'
import NProgress from 'nprogress'

import { apiClient } from 'Module/API/Client'

import * as CONST from 'Reducers/Inventory/const'
import * as ERRORS from 'Reducers/Errors/const'
import { callApi, afterCallApiInParallel } from 'Reducers/apiCall'
import { incUIBlockCounter, decBlockCounter } from 'Reducers/UIBlock/actions'

import { getParallelResponse } from 'Utils/Response'

/**
 * Add inventories by city id in parallel
 *
 * @param action
 */
function* addInventoriesByCityIdAll(action) {
  const { data, callbacks = {} } = action

  NProgress.start()
  yield put(incUIBlockCounter())

  try {
    const response = yield all(
      map(data, ({ cityId, payload }) =>
        call(apiClient.addInventoryByCityId, cityId, payload),
      ),
    )

    yield afterCallApiInParallel(response)

    const { ok, error } = yield getParallelResponse(response)

    if (ok) {
      yield put({
        type: CONST.ADD_INVENTORIES_BY_CITY_ID_ALL_SUCCESS,
      })
      callbacks.onSuccess && callbacks.onSuccess()
    } else {
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error,
      })
      callbacks.onError && callbacks.onError()
    }
  } catch (ex) {}

  yield put(decBlockCounter())
  NProgress.done()
}

/**
 * Get inventory types
 */
function* getInventoryTypes() {
  NProgress.start()
  const response = yield callApi(apiClient.getInventoryTypes)
  const responseJson = yield response.json()

  try {
    if (response.ok) {
      yield put({
        type: CONST.GET_INVENTORY_TYPES_SUCCESS,
        payload: {
          inventoryTypes: responseJson,
        },
      })
    } else {
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error: responseJson,
      })
    }
  } catch (ex) {}

  NProgress.done()
}

/**
 * Edit inventory
 */
function* editInventory(action) {
  const { callbacks, inventoryId, payload } = action

  NProgress.start()
  const response = yield callApi(apiClient.editInventory, inventoryId, payload)
  const responseJson = yield response.json()

  try {
    if (response.ok) {
      callbacks.onSuccess()
    } else {
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error: responseJson,
      })
    }
  } catch (ex) {}

  NProgress.done()
}

/**
 * Edit inventory in parallel
 */
function* editInventoryAll(action) {
  const { data, callbacks = {} } = action

  NProgress.start()
  const response = yield all(
    map(data, ({ inventoryId, payload }) =>
      call(apiClient.editInventory, inventoryId, payload),
    ),
  )

  yield afterCallApiInParallel(response)

  const { ok, error } = yield getParallelResponse(response)

  try {
    if (ok) {
      yield put({
        type: CONST.EDIT_INVENTORY_ALL_SUCCESS,
      })
      callbacks.onSuccess && callbacks.onSuccess()
    } else {
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error,
      })
      callbacks.onError && callbacks.onError()
    }
  } catch (ex) {}

  NProgress.done()
}

/**
 * Add inventories by city id in parallel watcher
 */
export function* watchAddInventoriesByCityIdAll() {
  yield takeLatest(
    CONST.ADD_INVENTORIES_BY_CITY_ID_ALL,
    addInventoriesByCityIdAll,
  )
}

/**
 * Get inventory types watcher
 */
export function* watchGetInventoryTypes() {
  yield takeLatest(CONST.GET_INVENTORY_TYPES, getInventoryTypes)
}

/**
 * Edit inventory
 */
export function* watchEditInventory() {
  yield takeLatest(CONST.EDIT_INVENTORY, editInventory)
}

/**
 * Edit inventory in parallel
 */
export function* watchEditInventoryAll() {
  yield takeLatest(CONST.EDIT_INVENTORY_ALL, editInventoryAll)
}
